// extracted by mini-css-extract-plugin
export default {"title":"styles_title__pJTwC","accent":"styles_accent__CC16Q","submitButton":"styles_submitButton__yuqSI","helpSection":"styles_helpSection__lmoLr"};